export class Share {

    constructor() {
        this.init();
    }

    init() {
        const shareData = {
            title: document.querySelector("meta[property='og:title']").content,
            text: document.querySelector("meta[property='og:description']").content,
            url: window.location.href,
        };

        const buttons = document.querySelectorAll('.js-share-button');
        buttons.forEach(btn => {
            btn.addEventListener("click", (event) => {
                event.preventDefault();
                this.openShareDialog(shareData);
            });
        })
    }

    openShareDialog(data) {
        this.showOverlay(data);
    }

    showOverlay(data) {
        window.ShareService.open(data);
    }
}
